import { useContext, useEffect } from "react"
import { Field, FastField } from "formik"
import { FormContext } from "../../context/formContext"
import { Dropdown } from "primereact/dropdown"
import us_states from "../../resources/us_states.json"
import fieldVisibility from "../../helpers/fieldVisibility"
import styles from "../../styles/Form.module.css"

function RegularFieldOutput(props) {
  const { field, isRequired, block, index } = props
  const form = useContext(FormContext)
  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: fieldVisibility(field.field_visibility),
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field name={field.field_name}>
          {({ field: formikField, meta, form: formik }) => (
            <>
              <Dropdown
                placeholder="Please select"
                name={formikField.name}
                value={formikField.value}
                onChange={formikField.onChange}
                disabled={isDisabled}
                options={us_states}
              />
              {meta.touched && meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )}
        </Field>
      </div>
    </div>
  )
}
function MultiFieldOutput(props) {
  const { field, isRequired, index, mfFieldName, mfIndex } = props
  const fieldSlug = `${mfFieldName}.${mfIndex}.${field.field_name}`
  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: fieldVisibility(field.field_visibility),
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <FastField name={fieldSlug}>
          {({ field: formikField, meta }) => (
            <>
              <Dropdown
                placeholder="Please select"
                id={field.field_name}
                name={formikField.name}
                value={formikField.value}
                onChange={formikField.onChange}
                options={us_states}
              />
              {meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )}
        </FastField>
      </div>
    </div>
  )
}
function NestedMultiFieldOutput(props) {
  const {
    field,
    isRequired,
    index,
    mfFieldName,
    mfIndex,
    nestedMfFieldName,
    nestedMfIndex,
  } = props
  const fieldSlug = `${mfFieldName}.${mfIndex}.${nestedMfFieldName}.${nestedMfIndex}.${field.field_name}`

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: fieldVisibility(field.field_visibility),
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <FastField name={fieldSlug}>
          {({ field: formikField, meta }) => (
            <>
              <Dropdown
                placeholder="Please select"
                id={field.field_name}
                name={formikField.name}
                value={formikField.value}
                onChange={formikField.onChange}
                options={us_states}
              />
              {meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )}
        </FastField>
      </div>
    </div>
  )
}

export default function TypeDropdownUsState(props) {
  const checkIfRequired = () => {
    try {
      return JSON.parse(props.field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()
  switch (props.type) {
    case "regular-field":
      const regFieldProps = {
        field: props.field,
        isRequired,
        block: props.block,
        index: props.index,
      }
      return <RegularFieldOutput {...regFieldProps} />
    case "multi-field":
      const multiFieldProps = {
        field: props.field,
        isRequired,
        index: props.index,
        mfFieldName: props.mfFieldName,
        mfIndex: props.mfIndex,
      }
      return <MultiFieldOutput {...multiFieldProps} />
    case "nested-multi-field":
      const nestedMultiFieldProps = {
        field: props.field,
        isRequired,
        index: props.index,
        mfFieldName: props.mfFieldName,
        mfIndex: props.mfIndex,
        nestedMfFieldName: props.nestedMfFieldName,
        nestedMfIndex: props.nestedMfIndex,
      }
      return <NestedMultiFieldOutput {...nestedMultiFieldProps} />
    default:
      return null
  }
}